'use strict';

define('vb/private/model/modelUtils',[
  'vb/private/utils',
  'vb/private/helpers/eventHelper',
  'vb/private/helpers/fragmentHelper',
  'vb/private/services/serviceResolverFactory',
], (Utils, EventHelper, FragmentHelper, ServiceResolverFactory) => {
  /**
   * @typedef {import('vb/private/services/serviceResolver').default} ServiceResolver
   */

  class ModelUtils {
    /**
     * if a JS module has a constructor, the constructor is called, and passed an object that contains accessors
     * for helpers.
     *
     * @param Module if falsy, returns null
     * @param container the container for this module
     * @returns {Object|null}
     */
    static initializeJsModule(module, container) {
      if (module && container) {
        const Module = Utils.getDefaultModule(module);

        if (typeof Module === 'function') {
          return new Module(this.createModuleContext(container));
        }
        return Module;
      }

      return null;
    }

    /**
     * passed to the module constructor; has an accessor to the EventHelper and ServiceResolver.
     * The container is assumed to be valid; if somehow, if it is not, the helper should still be
     * accessible by the JS, but it should fail will logging, minimally.
     *
     * @param container can be null/undefined; EventHelper will throw errors when used if not defined.
     * @returns {{ getEventHelper: (function(): *),
     *             getFragmentHelper: (function(): *),
     *             getServiceResolver: (function(): ServiceResolver),
     *             getRegistryHelper: (function(): { getAppUiInfoDigest: (function(): Promise<any>) }) }}
     * @private
     */
    static createModuleContext(container) {
      return {
        getEventHelper() {
          const eventHelper = new EventHelper({ container });
          // Add a way to dispose of the EventHelper when the container is deleted.
          container.unregisterEventArray.push(() => {
            eventHelper.dispose();
          });
          return eventHelper;
        },
        /**
         * Returns a Fragment Helper that allows a container holding one or more fragments to be disconnected.
         * @returns {*}
         */
        getFragmentHelper() {
          return new FragmentHelper({ container });
        },
        getServiceResolver() {
          return ServiceResolverFactory.getResolverForContainer(container);
        },
        getRegistryHelper() {
          return {
            async getAppUiInfoDigest() {
              return container.application.extensionRegistry.getAppUiInfoDigest();
            },
          };
        },
      };
    }
  }

  return ModelUtils;
});

